import { inject, Injectable, OnDestroy } from '@angular/core';
import { finalizeLoader } from '@app/shared/components';

import { AccountFacade } from '@corelabs/angular/account';
import { Subscription } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class AccountLoadersService implements OnDestroy {
    readonly accountFacade = inject(AccountFacade);

    private subscriptions$ = new Subscription();

    init() {
        this.subscriptions$.add(this.accountFacade.saving$.pipe(finalizeLoader('account')).subscribe());
    }

    ngOnDestroy(): void {
        this.subscriptions$.unsubscribe();
    }
}
